module.exports = __webpack_public_path__ + "static/media/sqwad_white_logo_w_text.312185fa.png";